import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, ReactNode } from "react";
import type { TokenMetadata } from "@/components/nft-picker/NftPicker.types";
import type { TokenListAction, TokenWindowEntry } from "../types";
import { TokenThumbnail } from "./TokenThumbnail";
type GridRowProps = Readonly<{
  tokens: TokenWindowEntry[];
  metadataMap: Map<string, TokenMetadata>;
  metadataQuery: any;
  renderTokenExtra?: ((tokenId: bigint, metadata?: TokenMetadata) => ReactNode) | undefined | undefined;
  action?: TokenListAction | undefined;
  positionStyle: CSSProperties;
  columns: number;
}>;
export function GridRow(t0) {
  const $ = _c(17);
  const {
    tokens,
    metadataMap,
    metadataQuery,
    renderTokenExtra,
    action,
    positionStyle,
    columns
  } = t0;
  const t1 = `repeat(${columns}, minmax(0, 1fr))`;
  let t2;
  if ($[0] !== positionStyle || $[1] !== t1) {
    t2 = {
      ...positionStyle,
      gridTemplateColumns: t1
    };
    $[0] = positionStyle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== action || $[4] !== metadataMap || $[5] !== metadataQuery || $[6] !== renderTokenExtra || $[7] !== tokens) {
    let t4;
    if ($[9] !== action || $[10] !== metadataMap || $[11] !== metadataQuery || $[12] !== renderTokenExtra) {
      t4 = token => {
        const metadata = metadataMap.get(token.decimalId);
        const isLoadingMetadata = metadataQuery.isFetching && !metadata;
        const hasMetadataError = metadataQuery.isError && !metadata;
        return <div key={token.decimalId} className="tw-flex tw-flex-col tw-rounded-lg tw-overflow-hidden"><div className="tw-aspect-square tw-w-full tw-overflow-hidden tw-bg-iron-900"><TokenThumbnail metadata={metadata} decimalId={token.decimalId} isLoading={isLoadingMetadata} hasError={hasMetadataError} /></div><div className="tw-flex tw-flex-col tw-p-3 tw-gap-3"><div className="tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-iron-400"><span className="tw-truncate">{metadata?.collectionName ?? "Collection"}</span><span className="tw-font-mono">#{token.decimalId}</span></div><div className="tw-flex tw-items-center tw-justify-between tw-gap-2"><div className="tw-font-medium tw-text-white tw-truncate">{metadata?.name ?? `Token #${token.decimalId}`}</div><div className="tw-flex tw-gap-1 tw-text-xs tw-shrink-0"><span className="tw-text-iron-400">xTDH</span><span className="tw-text-white">{Math.floor((token.xtdh ?? 0) * 10) / 10}</span></div></div></div>{renderTokenExtra?.(token.tokenId, metadata)}{action ? <div className="tw-p-3 tw-pt-0"><button type="button" className="tw-w-full tw-rounded tw-border tw-border-iron-700 tw-bg-transparent tw-px-2 tw-py-1.5 tw-text-xs tw-text-iron-200 hover:tw-border-primary-500 hover:tw-text-white" onClick={() => action.onClick(token.tokenId, metadata)} aria-label={action.getAriaLabel?.(`#${token.decimalId}`) ?? action.label}>{action.label}</button></div> : null}</div>;
      };
      $[9] = action;
      $[10] = metadataMap;
      $[11] = metadataQuery;
      $[12] = renderTokenExtra;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t3 = tokens.map(t4);
    $[3] = action;
    $[4] = metadataMap;
    $[5] = metadataQuery;
    $[6] = renderTokenExtra;
    $[7] = tokens;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <li className="tw-absolute tw-grid tw-w-full tw-gap-3 tw-px-3 tw-py-2" style={t2}>{t3}</li>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}